import { render } from "./uiModal.vue?vue&type=template&id=0a4747f6&scoped=true"
import script from "./uiModal.vue?vue&type=script&lang=js"
export * from "./uiModal.vue?vue&type=script&lang=js"

import "./uiModal.vue?vue&type=style&index=0&id=0a4747f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a4747f6"]])

export default __exports__